import React, { useMemo } from 'react';
import { FlexRow } from '@minecraft.atoms';
import { SelectionTagButton, SelectionTagButtonProps } from './SelectionTagButton';
import { SelectionTagType, TileValue } from './types';
import { getSelectionTileValuesToUse } from './utils';

export type SelectionTagsProps<SchemaType extends SelectionTagType> = {
  type: SchemaType;
  selectedValue: TileValue<SchemaType> | '';
  'data-qa-id'?: string;
  onSelected: (newValue: TileValue<SchemaType>) => void;
  disabled?: boolean;
  buttonSize?: SelectionTagButtonProps['size'];
  buttonMdProps?: SelectionTagButtonProps['mdProps'];
};

export const SelectionTags = <SchemaType extends SelectionTagType>({
  type,
  selectedValue,
  'data-qa-id': dataQaId,
  onSelected,
  disabled,
  buttonSize,
  buttonMdProps = {},
}: SelectionTagsProps<SchemaType>) => {
  const TAGS_TO_USE = useMemo(() => getSelectionTileValuesToUse(type), [type]);

  return (
    <FlexRow
      alignItems="center"
      className="cn_w-full"
      data-qa-id={dataQaId}
      data-testid="selection-tag-container"
      gap="1"
      justifyContent="space-evenly"
      wrap="nowrap"
      grow={0}
    >
      {TAGS_TO_USE.map((tag) => {
        const isSelected = selectedValue === tag;

        return (
          <SelectionTagButton
            size={buttonSize}
            selected={isSelected}
            disabled={typeof onSelected !== 'function' || disabled}
            key={tag}
            onSelected={() => onSelected(tag as TileValue<SchemaType>)}
            tag={tag}
            mdProps={buttonMdProps}
            data-qa-id={`selection-tag-btn-${tag}`}
          />
        );
      })}
    </FlexRow>
  );
};
